export default __webpack_public_path__ + "static/media/bgtos.7240eb94.jpg";